import { createContext } from "react"

export const DiscoveryHubContext = createContext()
